import styled from 'styled-components';

import { Button } from '../../Sections/Profile/Buttons';

export const Heading = styled.h3`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 105%;
    color: ${(props) => props.theme.colors.white};
    text-align: center;
    margin: 65px 0 0 0;
    padding: 0;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        font-size: 40px;
        line-height: 105%;
        margin: 70px 0 0 0;
    }
`;

export const SubHeading = styled.h3`
    font-family: 'Alliance No.1';
    font-style: normal;
    color: ${({ theme }) => theme.shades.white[50]};
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    text-align: center;
    margin: 6px 0 0 0;
    padding: 0;
    max-width: 280px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        font-weight: 600;
        font-size: 20px;
        line-height: 110%;
        margin: 20px 0 0 0;
        max-width: 370px;
    }
`;

export const HeadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 0 10px 0;
    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        margin: 0 0 20px 0;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 40px 0 0 0;
    width: 100%;
    padding: 0 10px;
    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        margin: 0 0 0 0;
        padding: 0 60px;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    width: 100%;
`;

export const ContentHeading = styled.h4`
    font-family: 'Alliance No.1';
    font-style: normal;
    color: ${(props) => props.theme.colors.white};
    text-align: left;
    font-weight: 700;
    font-size: 18px;
    line-height: 100%;
    width: 100%;
    margin: 0 0 20px 0;
    letter-spacing: -0.02em;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        font-size: 16px;
        margin: 0 0 15px 0;
    }
`;

export const CTAButton = styled(Button)`
    width: 100% !important;
    margin: 30px 0 0 0 !important;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        width: 170px !important;
        height: 56px !important;
        min-height: unset !important;
        margin: 40px 0 60px 0 !important;
    }
`;
